import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { LangService } from "src/app/core/services/lang.service";
import { GridService } from "src/app/shared/services/grid.service";
import { DataLoadService } from "src/app/shared/services/data-load.service";

@Component({
  selector: "app-floor-shift-list",
  templateUrl:
    "./../../../templates/forms/modals/floor-list.component.html"
})
export class HrFloorComponent implements OnInit {
  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  optionalParam: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "HrComLineListid";

  dataObj: any;
  floorList = [];
  public searchString;
  constructor(
    public langService: LangService,
    public gridService: GridService,
    private dataLoadService: DataLoadService
  ) {
    this.colObj = [
      {
        headerName: langService.langData.floorName,
        field: "FLOOR_NAME",
        sortable: true,
        resizable: true,
        hide: false
      },
      {
        headerName:langService.langData.floorNo,
        field: "FLOOR_NO",
        sortable: true,
        resizable: true,
        hide: false
      }
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);

    this.dataLoadService.load("FG_HR_COMM_FLOOR_LIST", this.optionalParam).subscribe(result => {
      this.floorList = result.body;
    });
  }
  itemClick(_item) { 
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }
}
